import React, { useState } from "react";
import styles from "./Login.module.css";
import Navbar from "../../layouts/navbar/Navbar";
import Button from "../../components/custom-button/Button";
import Footer from "../../layouts/footer/Footer";
import { reactIcons } from "../../icons/reactIcons";
import { useNavigate } from "react-router-dom";
import { authApis } from "../../apis/authApis";
import { encryptAES } from "../../utils/encryption";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg("");
    setLoading(true);

    try {
      const encryptedEmail = encryptAES(email);
      const encryptedPassword = encryptAES(password);

      const res = await authApis.login({
        email: encryptedEmail,
        password: encryptedPassword,
      });

      console.log("res", res);

      const token = res?.data?.accessToken;
      const name = `${res?.data?.firstName} ${res?.data?.lastName}`;

      if (!res?.success) {
        setErrorMsg(res?.data?.message);
        return;
      }

      localStorage.setItem("LVaccessToken", token);
      localStorage.setItem("LVFname", name);
      localStorage.setItem("LVuser", JSON.stringify(res.data));

      navigate("/", { replace: true });
    } catch (error: any) {
      console.log(error);
      setErrorMsg(error?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <Navbar />

      <div className={styles.loginContainer}>
        <h2 className={styles.loginTitle}>Inspector Portal</h2>
        <p className={styles.loginSubtitle}>Log in to submit reports</p>

        <form className={styles.loginForm} onSubmit={handleSubmit}>
          <label>
            Email Address <span className={styles.required}>*</span>
          </label>
          <input
            type="email"
            placeholder="your.email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>
            Password <span className={styles.required}>*</span>
          </label>
          <div className={styles.passwordContainer}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span
              className={styles.toggleIcon}
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? (
                <reactIcons.EyeIcon style={{ fontSize: "27px" }} />
              ) : (
                <reactIcons.EyeOffIcon style={{ fontSize: "27px" }} />
              )}
            </span>
          </div>

          {errorMsg && <p className={styles.errorText}>{errorMsg}</p>}

          <div className={styles.loginAction}>
            <Button
              label={loading ? "Logging in.." : "Login"}
              type="submit"
              disabled={!email || !password || loading}
            />
          </div>
        </form>
      </div>

      <Footer />
    </div>
  );
};

export default Login;
